<template>
  <v-container fluid>
    <v-row>
       <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.specialistID')}}
                  <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.specialistIDState')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    getdrug.specialistId
                      ? getdrug.specialistId
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.specialistName')}}
                  <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.specialistNameState')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    getdrug.specialistName
                      ? getdrug.specialistName
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.specialistComments')}}<v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.specialistCommentsState')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    getdrug.specialistComment
                      ? getdrug.specialistComment
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.recepientAnimalId')}}<v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.recepientAnimalIdState')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                     {{
                    getdrug.packRecepientAnimalId
                      ? getdrug.packRecepientAnimalId
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.recepientFarmId')}}
                  <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.recepientFarmIdStatement')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{ getdrug.packRecepientFarmId ? getdrug.packRecepientFarmId : "Not Specified" }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.recepientKeeperId')}}<v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.recepientKeeperIdStatement')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    getdrug.packRecepientKeeperId
                      ? getdrug.packRecepientKeeperId
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <!-- <v-col cols="12" sm="6" md="4">
        <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon>
        <v-text-field
          :value="getdrug.specialistId"
          label="Specialist "
          readonly
          class="font-weight-bold"
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon>
        <v-text-field
          :value="getdrug.specialistName"
          label="Specialist Name"
          readonly
          class="font-weight-bold"
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon>
        <v-text-field
          :value="getdrug.specialistComment"
          label="Specialist Comments"
          readonly
          class="font-weight-bold"
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon>
        <v-text-field
          :value="getdrug.packRecepientAnimalId"
          label="Recepient Animal Id"
          readonly
          class="font-weight-bold"
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon>
        <v-text-field
          :value="getdrug.packRecepientFarmId"
          label="Recepient Farm Id"
          readonly
          class="font-weight-bold"
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon>
        <v-text-field
          :value="getdrug.packRecepientKeeperId"
          label="Recepient Keeper Id"
          readonly
          class="font-weight-bold"
        ></v-text-field>
      </v-col> -->
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "PackPrescription",
  computed: {
    ...mapGetters(["getdrug"]),
  },
};
</script>